import { createSignal } from "solid-js";

import { registerSW } from "virtual:pwa-register";

// Exported for backwards-compatible imports (e.g. the desktop Titlebar). With
// registerType "prompt" the new worker is staged in the background and takes
// over on the next navigation, so we never surface a manual-reload action -
// this stays unset in practice.
const [pendingUpdate] = createSignal<() => void>();

export { pendingUpdate };

if (import.meta.env.PROD) {
  registerSW({
    onOfflineReady() {
      console.info("Ready to work offline =)");
    },
    onRegistered(r) {
      if (!r) return;
      // Re-check for a new deployment periodically and whenever the tab regains
      // focus, so the new worker is already staged when the tab next navigates.
      setInterval(() => r.update(), 15 * 60 * 1000);
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") r.update();
      });
    },
  });
}
